export const getRepresentativeLegalWarningStartText = (companyName) =>
  `If you are not a legal business representative of ${companyName}, you must`;

export const getRepresentativeContactText = (fullName, email) => `I am ${fullName} (${email}).`;

export const getRepresentativeCompanyNameText = (companyName) => `I am a business representative for ${companyName}.`;
